import { Stack, TableCell, TableHead, TableRow } from '@mui/material';
import InfoToolTip from 'containers/common/components/InfoToolTip';
import React, { memo } from 'react';

function TransactionalQuestionTableHead() {
  return (
    <TableHead>
      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
        <TableCell sx={{ width: { xs: '200px', sm: '40%' }, minWidth: '150px', fontWeight: 600 }}>
          <Stack direction="row" alignItems="center">
            Transaction Date
          </Stack>
        </TableCell>
        <TableCell sx={{ width: { xs: '150px', sm: '20%' }, minWidth: '120px', fontWeight: 600 }}>
          Total Amount
        </TableCell>
        <TableCell sx={{ width: { xs: '150px', sm: '20%' }, minWidth: '120px', fontWeight: 600 }}>
          Line Amount
        </TableCell>
        <TableCell sx={{ width: { xs: '200px', sm: '40%' }, minWidth: '150px', fontWeight: 600 }}>
          <Stack direction="row" alignItems="center" justifyContent="flex-end" gap="1">
            Latest Answer
            <InfoToolTip
              title="Indicates the most recent answer provided for the transactional question. To view all answers, click the button below to open the detailed view."
              fontSize="16px"
            />
          </Stack>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

export default memo(TransactionalQuestionTableHead);
